<template>
  <Popover
    v-slot="{ open }: { open: boolean }"
    as="div"
  >
    <PopoverButton
      class="body-md wc-focus flex items-center gap-x-1 border-b-4 px-2 py-3 font-semibold text-gray-800 transition duration-300 ease-out focus-visible:outline-offset-1"
      :class="open ? 'border-primary-500 text-primary-500' : 'border-transparent hover:border-gray-100 hover:text-primary-500'"
      @click="handlePopoverClick"
      @keydown.enter="handlePopoverClick"
    >
      {{ buttonText }}
      <IconCaretDownFilled
        :size="16"
        class="text-gray-800"
        :class="{ 'rotate-180': open }"
        aria-hidden="true"
      />
    </PopoverButton>
    <Transition
      enter-active-class="transition duration-300 ease-out motion-reduce:transition-none motion-reduce:hover:transform-none"
      enter-from-class="translate-y-1 opacity-0"
      enter-to-class="translate-y-0 opacity-100"
      leave-active-class="transition duration-200 ease-in motion-reduce:transition-none motion-reduce:hover:transform-none"
      leave-from-class="translate-y-0 opacity-100"
      leave-to-class="translate-y-1 opacity-0"
    >
      <PopoverPanel
        as="div"
        class="absolute left-1/2 top-full z-10 mt-px w-full max-w-5xl -translate-x-1/2 rounded-b-2xl bg-white p-8 shadow-sm"
      >
        <slot />
      </PopoverPanel>
    </Transition>
  </Popover>
</template>

<script setup lang="ts">
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { IconCaretDownFilled } from '@tabler/icons-vue'

import { usePopover } from '@js/composables/usePopover'

defineOptions({
  name: 'AppDropdownMenu',
})

defineProps<{
  buttonText: string
}>()

const { handlePopoverClick } = usePopover()
</script>
